import 'babel-polyfill'

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('../Scripts/cdh-base/', true, /\.js$/));
import 'script-loader!../Scripts/script-loader/cookie-helper'
import 'script-loader!../Scripts/script-loader/dateFormat'
import 'script-loader!../Scripts/script-loader/all-pages-actions';
